/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React, { useState, useRef, memo } from 'react';
import { Segment, Icon } from 'semantic-ui-react';
import { shape, func, string } from 'prop-types';

import styles from './FileInputURL.less';

export const TYPE_FILE = 1;
export const TYPE_APPOINTMENT = 2;

const FileInputItem = props => {
  const { onFileSelected, handleFileRemove, fileUpload, fileName, value } = props;

  const [showIndicator, setShowIndicator] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showDimmer, setShowDimmer] = useState(false);
  const inputRef = useRef();

  const handleSelectedFile = async evt => {
    try {
      const file = evt.target.files[0];
      if (file) {
        const formData = new FormData();
        formData.append('is_public', true);
        formData.append('file', file, `${fileName}_${Date.now()}.png`);

        setLoading(true);
        const newValue = await fileUpload(formData);

        onFileSelected(value, newValue);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleMouseOver = () => {
    setShowDimmer(true);
  };

  const handleMouseLeave = () => {
    setShowDimmer(false);
  };

  const handleLoad = () => {
    setShowIndicator(false);
  };

  const triggerInputFile = () => {
    if (!loading) inputRef.current.click();
  };

  const handleRemove = e => {
    e.stopPropagation();
    handleFileRemove(value);
  };

  const styleDisplayDimmer = showDimmer ? 'flex' : 'none';
  const styleDisplayIndicator = showIndicator ? 'flex' : 'none';
  const hasValue = value && value.thumbnailUrl;
  return (
    <div className={styles.buttonContainer} onClick={triggerInputFile}>
      {loading && <Segment style={{ position: 'absolute' }} basic loading width="100%" />}

      <div
        className={styles.viewer}
        style={{ display: styleDisplayDimmer }}
        onMouseLeave={handleMouseLeave}
        role="presentation">
        {hasValue ? 'Change' : 'Upload'}
      </div>
      <div className="ui loader" style={{ display: styleDisplayIndicator, position: 'absolute' }} />
      {hasValue ? (
        <>
          <img
            src={value.thumbnailPath}
            className={styles.img}
            title="Change image"
            onMouseOver={handleMouseOver}
            onLoad={handleLoad}
            alt=""
          />
          <div className={styles.remove} onClick={handleRemove}>
            <Icon name="remove" link />
          </div>
        </>
      ) : (
        <Icon link name="upload" className={styles.iconUpload} />
      )}

      <input
        type="file"
        onChange={handleSelectedFile}
        style={{ display: 'none' }}
        ref={inputRef}
        accept="image/png, image/jpeg"
      />
    </div>
  );
};

FileInputItem.propTypes = {
  value: shape({}),
  handleFileRemove: func,
  onFileSelected: func,
  fileUpload: func,
  fileName: string.isRequired,
};

FileInputItem.defaultProps = {
  value: null,
  handleFileRemove: () => {},
  onFileSelected: () => {},
  fileUpload: () => {},
};

export default memo(FileInputItem);
